// https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/
import {Directive, ElementRef, Output, EventEmitter, HostListener} from '@angular/core';

@Directive(
    {selector: '[clickOutsideDirective]'}
)
export class ClickedOutsideDirective {
    constructor(private _elementRef: ElementRef) {
    }

    @Output()
    public clickOutside: EventEmitter<any> = new EventEmitter<any>();

    @HostListener('document:click', ['$event.target'])
    public onClick(clickedElement: HTMLElement) {
        const clickedInsideElement: boolean = this._elementRef.nativeElement.contains(clickedElement);
        if (clickedInsideElement) {
            this.clickOutside.emit({
                IsItInside: true,
                Id: clickedElement['id']
            });
        } else {
            this.clickOutside.emit({
                IsItInside: false,
                Id: clickedElement['id']
            });
        }
    }
}
